/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AIModelInferenceRequest
 */
export interface AIModelInferenceRequest {
    /**
     * 
     * @type {number}
     * @memberof AIModelInferenceRequest
     */
    proxy: number;
    /**
     * 
     * @type {number}
     * @memberof AIModelInferenceRequest
     */
    frameStart?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AIModelInferenceRequest
     */
    frameEnd?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AIModelInferenceRequest
     */
    frameStep?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AIModelInferenceRequest
     */
    skipStep?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AIModelInferenceRequest
     */
    combineThreshold?: number | null;
}

export function AIModelInferenceRequestFromJSON(json: any): AIModelInferenceRequest {
    return AIModelInferenceRequestFromJSONTyped(json, false);
}

export function AIModelInferenceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AIModelInferenceRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'proxy': json['proxy'],
        'frameStart': !exists(json, 'frame_start') ? undefined : json['frame_start'],
        'frameEnd': !exists(json, 'frame_end') ? undefined : json['frame_end'],
        'frameStep': !exists(json, 'frame_step') ? undefined : json['frame_step'],
        'skipStep': !exists(json, 'skip_step') ? undefined : json['skip_step'],
        'combineThreshold': !exists(json, 'combine_threshold') ? undefined : json['combine_threshold'],
    };
}

export function AIModelInferenceRequestToJSON(value?: AIModelInferenceRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'proxy': value.proxy,
        'frame_start': value.frameStart,
        'frame_end': value.frameEnd,
        'frame_step': value.frameStep,
        'skip_step': value.skipStep,
        'combine_threshold': value.combineThreshold,
    };
}


